<template>
  <ValidationObserver
      ref="observer"
      class="transition duration-500 ease-in-out transform w-full"
      style="transition: all 1s !important"
      tag="form"
      @submit.prevent="submit()"
  >
    <div class="lookup-form">
      <v-card class="mx-auto w-full lookup-form__card" flat>
        <div class="lookup-form__grid flex flex-wrap my-2 mx-6 mb-4">
          <div class="w-full px-3 mb-6 required">
            <label
                class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
            >Facility's Name</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <input
                  id="name"
                  v-model="formValues.name"
                  class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  name
                  type="text"
              />
              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>
          </div>


          <div class="w-full md:w-1/3 px-3 md:mb-0 required">
            <label
                class="
                    block
                    uppercase
                    tracking-wide
                    text-gray-700 text-xs
                    font-bold
                    mb-2
                  "
            >Region</label
            >
            <validation-provider v-slot="{ errors }" rules="required">
              <v-select
                  v-model="formValues.region_id"
                  :elevation="1"
                  :items="LOCATIONS"
                  :loading="lookupLoading"
                  dense
                  item-text="name"
                  item-value="id"
                  solo
                  @change="fetchLocation('zone', formValues.region_id)"
              ></v-select>

              <span class="text-gray-600 text-xs italic text-red-700">{{
                  errors[0]
                }}</span>
            </validation-provider>

            <br/>
          </div>
          <div class="w-full md:w-1/3 px-3 md:mb-0 ">
            <label
                class="
                    block
                    uppercase
                    tracking-wide
                    text-gray-700 text-xs
                    font-bold
                    mb-2
                  "
            >Zone</label
            >

            <v-select
                v-model="formValues.zone_id"
                :elevation="1"
                :items="ZONES"
                :loading="zoneLoading"
                dense
                item-text="name"
                item-value="id"
                solo
                @change="fetchLocation('woreda', formValues.zone_id)"
            ></v-select>

            <br/>
          </div>
          <div class="w-full md:w-1/3 px-3 md:mb-0">
            <label
                class="
                    block
                    uppercase
                    tracking-wide
                    text-gray-700 text-xs
                    font-bold
                    mb-2
                  "
            >Woreda</label
            >

            <v-select
                v-model="formValues.woreda_id"
                :elevation="1"
                :items="WOREDAS"
                :loading="woredaLoading"
                dense
                item-text="name"
                item-value="id"
                solo
            ></v-select>

            <br/>
          </div>
        </div>
        <div class="lookup-form__actions">
          <v-btn class="lookup-form__cancel" text type="button" @click="$emit('close')">
            Cancel
          </v-btn>
          <v-btn
              :disabled="formValues.name === null"
              class="lookup-form__submit white--text"
              color="primary"
              depressed
              @click="submit()"
          >
            {{ formValues.editMode ? "Update" : "Add" }}
          </v-btn>
        </div>
      </v-card>
    </div>
  </ValidationObserver>
</template>

<script>
import {extend, ValidationObserver, ValidationProvider} from "vee-validate";
import {required} from "vee-validate/dist/rules";
import {getRegionList} from "../../../utils/helper";
import {UserFacilitiesService} from "../user-facility/userFacility.service";

extend("required", {

  ...required,
  message: "This field is required",
});
export default {
  props: {
    traineeFacility: Object,
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      formValues: {
        name: null,
        code: null,
        isActive: true,
        editMode: false,
        region_id: null,
        zone_id: null,
        woreda_id: null,
      },
      today: new Date().toISOString().substr(8, 11),
      disableAdd: true,
      FACILITY_TYPES: [],
      LOCATIONS: [],
      ZONES: [],
      WOREDAS: [],
      lookupLoading: false,
      zoneLoading: false,
      woredaLoading: false,
    };
  },
  async created() {
    this.LOCATIONS = await getRegionList();

    if (this.traineeFacility != null) {
      this.formValues = this.traineeFacility;
      if (this.formValues.region_id) {
        this.fetchLocation("zone", this.formValues.region_id);
      }
      if (this.formValues.zone_id) {
        this.fetchLocation("woreda", this.formValues.zone_id);
      }
      this.formValues.editMode = true;
    }
  },
  methods: {
    async fetchLocation(type, id) {
      switch (type) {
        case "zone":
          this.zoneLoading = true;
          this.ZONES = await UserFacilitiesService.getLocationByType(type, id);
          this.zoneLoading = false;
          break;
        case "woreda":
          this.woredaLoading = true;
          this.WOREDAS = await UserFacilitiesService.getLocationByType(
              type,
              id
          );
          this.woredaLoading = false;
          break;

        default:
          break;
      }
    },
    async submit() {
      if (!(await this.$refs.observer.validate())) return;
      this.$refs.observer.validate();
      this.$emit("registerOrUpdateTraineeFacility", this.formValues);
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.required > label::after {
  content: "*";
  color: red;
  padding-left: 3px;
}

input:disabled {
  background: #ccc;
}
</style>
